import { Component, ComponentFactoryResolver, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Models } from '@ibexfusion/models';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { FormDirective } from '../../../directives/form/form.directive';
import { ProfileService } from '@services/profiles/profile.service';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { DefaultFormComponent } from '../../../components/default-form/default-form.component';
import { FormComponent } from '../../../components/default-form/form.component';
import { CredentialsService } from '@services/credentials/credentials.service';

@Component({
    selector: 'app-profile-edit',
    templateUrl: './profile-edit.component.html',
    styleUrls: ['./profile-edit.component.scss'],
    providers: [ProfileService, CredentialsService],
    standalone: false
})
export class ProfileEditComponent implements OnInit {

  @ViewChild(FormDirective, { static: true }) formHost: FormDirective;

  pageActions: PageAction[];

  title = 'Edit Profile';
  create = false;
  isLoading = true;
  boundProfile: Models.Profile;
  profileId: string;
  credentialObject: any = null;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private profileService: ProfileService,
    private activatedRoute: ActivatedRoute,
    private snackbar: SnackbarService,
    private router: Router,
    private credentialsService: CredentialsService
  ) {
  }

  ngOnInit() {
    if (this.activatedRoute.snapshot.params['id']) {
      this.profileId = this.activatedRoute.snapshot.params['id'];
      this.profileService.get(this.activatedRoute.snapshot.params['id']).then(result => {
        this.boundProfile = result;
        if (this.boundProfile && (this.boundProfile.nickName || this.boundProfile.firstName || this.boundProfile.lastName)) {
          this.title = this.boundProfile.nickName ? this.boundProfile.nickName : this.boundProfile.firstName + ' ' + this.boundProfile.lastName;
        }
        this.isLoading = false;
        this.loadForm();
        this.createPageActions();
      });
    } else {
      this.title = 'Create new Profile';
      this.create = true;
      this.boundProfile = <Models.Profile>Models.ModelFactory.createModelInstanceByName('Profile');
      this.boundProfile.userType = 'ibexfusion';
      this.boundProfile.isAnonymous = false;
      this.isLoading = false;
      this.loadForm();
    }

  }

  loadForm() {
    const formItem = DefaultFormComponent;

    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(formItem);

    const viewContainerRef = this.formHost.viewContainerRef;
    viewContainerRef.clear();

    const componentRef = viewContainerRef.createComponent(componentFactory);
    (<FormComponent>componentRef.instance).entry = this.boundProfile;
  }

  onSave() {
    return this.boundProfile.validate(true).then(result => {
      if (result.success) {
        if (this.profileId) {
          this.profileService.update(this.profileId, this.boundProfile, { query: { updateSettings: true } }).then(profileResult => {
            this.snackbar.success('Successfull updated Profile');
            this.router.navigate(['profiles']);
          });
        } else {
          this.checkUniqueEmail().then(unique => {
            if (unique) {
              this.profileService.create(this.boundProfile).then(profileResult => {
                this.snackbar.success('Successfull created new Profile');
                this.router.navigate(['profiles']);
              });
            } else {
              this.snackbar.open('Could not create Profile, because Profile with email and userType already exists');
            }
          });

        }
      } else {
        this.snackbar.open('Could not create the profile, please fill the form correctly');
      }
    });
  }

  checkUniqueEmail(): Promise<boolean> {
    if (!this.boundProfile.email) {
      return Promise.resolve(true);
    }
    return this.profileService.find(0, 100, { email: this.boundProfile.email, userType: this.boundProfile.userType }).then(profiles => {
      if (profiles && profiles.data && profiles.data.length) {
        console.log('found identical emails: ', profiles);
        return Promise.resolve(false);
      }
      return Promise.resolve(true);
    });
  }

  requestCredentials() {
    this.credentialsService.get(this.boundProfile.ProfileID).then(result => {
      if (!result || result.length === 0) {
        this.credentialObject = { status: 'noCredentials for ProfileID: ' + this.boundProfile.ProfileID };
        return;
      }
      if (result.length > 1) {
        this.snackbar.open('Problem: There are more then one Credential for this user');
      }
      this.credentialObject = result[0];
    });
  }

  getEmail() {
    this.credentialsService.get(this.boundProfile.ProfileID).then(result => {
      if (!result || result.length === 0 || !result[0].loginName) {
        this.snackbar.error('Could not get email from credentials');
        return;
      }
      this.boundProfile.email = result[0].loginName;
      this.onSave();
    });
  }

  createPageActions() {
    this.pageActions = [
      new PageAction({
        icon: 'info',
        title: 'Detail Profile',
        callback: () => {
          this.router.navigate(['profiles', this.activatedRoute.snapshot.params['id']]);
        }
      }),
      new PageAction({
        icon: 'info',
        title: 'Check Credentials',
        callback: () => {
          this.requestCredentials();
        }
      })
    ];
  }
}
